export default "__VITE_ASSET__BHocNlOI__"